import type { Editor } from "./editorTypes";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: Editor = {
  component_uuid: null,
  component_parent_uuid: null,
  component_id: null,
  component_parent_id: null,
  hasEdited: false,
  editor: null,
  template: null,
};

export const editorSlice = createSlice({
  name: "editor",
  initialState,
  reducers: {
    UPDATE_EDITOR: (state, action: PayloadAction<Partial<Editor>>) => {
      const p = action.payload;
      return {
        ...state,
        ...p,
        component_uuid:
          p.component_uuid !== undefined ? p.component_uuid : state.component_uuid,
        component_parent_uuid:
          p.component_parent_uuid !== undefined
            ? p.component_parent_uuid
            : state.component_parent_uuid,
        component_id: p.component_id !== undefined ? p.component_id : state.component_id,
        component_parent_id:
          p.component_parent_id !== undefined
            ? p.component_parent_id
            : state.component_parent_id,
        hasEdited: p.hasEdited !== undefined ? p.hasEdited : state.hasEdited,
        editor: p.editor !== undefined ? p.editor : state.editor,
        template: p.template !== undefined ? p.template : state.template,
      };
    },

    UPDATE_EDITOR_STATE: (
      state,
      action: PayloadAction<{
        hasEdited: boolean;
      }>
    ) => {
      state.hasEdited = action.payload.hasEdited;
    },

    UPDATE_ACTIVE_EDITOR: (state, action: PayloadAction<Editor>) => {
      return action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { UPDATE_EDITOR, UPDATE_ACTIVE_EDITOR, UPDATE_EDITOR_STATE } =
  editorSlice.actions;

export default editorSlice.reducer;
